import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    noResults: {
        /** Title shown when no search results are found */
        title: string;
        /** Description suggesting how to get more results */
        description: string;
        /** Button label to clear all filters */
        buttonLabel: string;
    };
    error: {
        /** Title shown when a search error occurs */
        title: string;
        /** Button label to retry the search */
        buttonLabel: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            noResults: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title shown when no search results are found */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResultsMessage.noResults.title?c=bxwc8l3o0rop", defaultMessage: "No Results Found" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description suggesting how to get more results */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResultsMessage.noResults.description?c=3nlqnrd36l6rf", defaultMessage: "Try tweaking your search or clearing filters to see more results." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Button label to clear all filters */
                        buttonLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResultsMessage.noResults.buttonLabel?c=2tdge0d9wlhny", defaultMessage: "Clear All" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            error: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title shown when a search error occurs */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResultsMessage.error.title?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Button label to retry the search */
                        buttonLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResultsMessage.error.buttonLabel?c=24r9hk1amvd4v", defaultMessage: "Retry" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
